<p>device-overview-widget works!</p>
